/* ============================================================
   Upakarna, Bundle Cart Guard
   Keeps personalised bundles AND jewellery bouquets atomic.

   Personalisation rules (lines share hidden _pzid; the base line carries
   _pz_head=true and, where the builder knows them, a Personalisation list):
   1. Main product removed  -> all its _pzid charm lines removed.
   2. Charm quantities always equal (occurrences in the
      Personalisation string) x (main line quantity).

   Bouquet rules (lines share visible 'Bouquet' property; the
   charge line also carries 'Contains' listing every piece):
   3. If any piece of a bouquet is removed (or the charge line
      itself), the ENTIRE bouquet is removed from the cart.
   4. Bouquet line quantities are locked to 1.
   ============================================================ */
(function () {
  'use strict';
  if (window.UpkCartGuard) return;

  // Shared, short-window cached /cart.js read, identical copy of the same
  // helper in assets/up-cart-drawer.js. Both files react to the same cart
  // events (assets/upk-cart-events.js, the one fetch interceptor since P2),
  // and previously each did its own /cart.js GET when a mutation fired, so a
  // single add/change could cause 2+ near-simultaneous fetches. The cache lives on
  // `window` (not a variable local to either file) so whichever file's copy
  // of this function runs first within the 300ms window is reused by the
  // other, instead of firing a second request. Kept identical to
  // up-cart-drawer.js's copy on purpose, if only one of the two files
  // loads on a given page, that copy alone still works standalone.
  function upkFetchCartFresh() {
    var now = Date.now();
    if (window.__upkCartCachePromise && (now - (window.__upkCartCacheTime || 0)) < 300) {
      return window.__upkCartCachePromise;
    }
    window.__upkCartCacheTime = now;
    window.__upkCartCachePromise = fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); });
    return window.__upkCartCachePromise;
  }

  var guard = (window.UpkCartGuard = {
    enforcing: false,
    timer: null,
    schedule: function () {
      clearTimeout(guard.timer);
      guard.timer = setTimeout(guard.enforce, 350);
    },
    enforce: function () {
      if (guard.enforcing) return;
      upkFetchCartFresh()
        .then(function (cart) {
          var updates = {};

          /* ---------- personalised bundles (_pzid) ---------- */
          var groups = {};
          (cart.items || []).forEach(function (it) {
            var pz = it.properties && it.properties._pzid;
            if (!pz) return;
            (groups[pz] = groups[pz] || []).push(it);
          });
          Object.keys(groups).forEach(function (pz) {
            var lines = groups[pz];
            var main = null;
            for (var i = 0; i < lines.length; i++) {
              var lp = lines[i].properties || {};
              /* Phase 4: every builder marks its base line _pz_head; the Personalisation string is the older marker. */
              if (lp.Personalisation || lp._pz_head === 'true' || lp._pz_head === true) { main = lines[i]; break; }
            }
            if (!main) {
              lines.forEach(function (l) { updates[l.key] = 0; });
              return;
            }
            if (!main.properties.Personalisation) return; /* head without a letter list: keep the group, nothing to sync */
            var labels = String(main.properties.Personalisation).split(' + ');
            var counts = {};
            labels.forEach(function (L) { counts[L] = (counts[L] || 0) + 1; });
            lines.forEach(function (l) {
              if (l === main) return;
              var label = null;
              var opts = l.variant_options || [];
              for (var j = 0; j < opts.length; j++) {
                if (counts[opts[j]] != null) { label = opts[j]; break; }
              }
              if (label == null) return;
              var expected = counts[label] * main.quantity;
              if (l.quantity !== expected) updates[l.key] = expected;
            });
          });

          /* ---------- gift note: one per order (OPEN-ITEMS 48) ---------- */
          (cart.items || []).forEach(function (it) {
            if (it.handle === 'gift-card' && it.quantity > 1) updates[it.key] = 1;
          });

          /* ---------- jewellery bouquets ('Bouquet' property) ---------- */
          var bgroups = {};
          (cart.items || []).forEach(function (it) {
            var b = it.properties && it.properties.Bouquet;
            if (!b) return;
            (bgroups[b] = bgroups[b] || []).push(it);
          });
          Object.keys(bgroups).forEach(function (b) {
            var lines = bgroups[b];
            var charge = null;
            lines.forEach(function (l) {
              if (l.properties && l.properties.Contains) charge = l;
            });
            var broken = false;
            if (!charge) {
              broken = true; /* charge/bundle line removed -> dissolve */
            } else {
              var expected = String(charge.properties.Contains).split(' \u2022 ').length;
              var pieces = lines.length - 1;
              if (pieces < expected) broken = true; /* a piece was removed */
            }
            if (broken) {
              lines.forEach(function (l) { updates[l.key] = 0; });
            } else {
              lines.forEach(function (l) { if (l.quantity !== 1) updates[l.key] = 1; });
            }
          });

          var keys = Object.keys(updates);
          if (!keys.length) return;
          guard.enforcing = true;
          return fetch(((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              updates: updates,
              sections: 'cart-drawer,cart-icon-bubble',
              sections_url: window.location.pathname
            })
          })
            .then(function (r) { return r.json(); })
            .then(function (state) {
              if (document.querySelector('cart-items')) {
                window.location.reload();
                return;
              }
              var drawer = document.querySelector('cart-drawer');
              if (drawer && state.sections && typeof drawer.renderContents === 'function') {
                var wasOpen = drawer.classList.contains('active');
                drawer.renderContents(state);
                if (!wasOpen) {
                  setTimeout(function () {
                    drawer.classList.remove('active', 'animate');
                    document.body.classList.remove('overflow-hidden');
                  }, 120);
                }
              }
              if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
                window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'upk-cart-guard' });
              }
            })
            .finally(function () { guard.enforcing = false; });
        })
        .catch(function () { guard.enforcing = false; });
    }
  });

  /* Every cart mutation, whichever script makes it, arrives as an event from assets/upk-cart-events.js
     (the one fetch interceptor, P2.1). */
  function onCartEvent() { if (!guard.enforcing) guard.schedule(); }
  document.addEventListener('upk:cart:add', onCartEvent);
  document.addEventListener('upk:cart:change', onCartEvent);

  document.addEventListener('DOMContentLoaded', function () {
    guard.schedule();
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (!evt || !evt.source || evt.source !== 'upk-cart-guard') guard.schedule();
      });
    }
  });
})();
